import React from "react";
import { Outlet } from "react-router-dom";
import { Shell } from "@/components/Shell";
import { LayoutDashboard, QrCode, Send, FileText } from "lucide-react";

const nav = [
  { to: "/app", end: true, label: "Dashboard", icon: LayoutDashboard, testid: "nav-dashboard" },
  { to: "/app/qr", label: "Collect (QR)", icon: QrCode, testid: "nav-qr" },
  { to: "/app/payout", label: "Payout", icon: Send, testid: "nav-payout" },
  { to: "/app/statement", label: "Statement", icon: FileText, testid: "nav-statement" },
];

export default function UserLayout() {
  return (
    <Shell nav={nav} portalLabel="Merchant">
      <Outlet />
    </Shell>
  );
}
